import styled from "styled-components";

export const App = styled.div`
  font-family: "Noto Sans Display", sans-serif;
  width: 100%;
  height: 100%;
`;
